import L, { type PointExpression } from 'leaflet'
import { throttle } from 'lodash-unified'
import { CanvasShipUtils } from '@map-sdk/sdk/utils/CanvasShipUtils'
import { ShipxyOptions } from '@map-sdk/sdk/config'
import { CommUtils } from '@map-sdk/sdk/utils/CommUtils'
import { canvasIconLayer } from '@map-sdk/sdk/plugins/canvasMarker'
// import 'leaflet-canvas-marker'
import { resultDatas } from './NavigationData'

class CanvasNavigation {
  mmsi = ''
  lng = 0
  lat = 0
  lastdyn = 0
  shiptype = 'navigation'
  type = 0
  name = ''
  length = 0
  width = 0
  left = 0
  trail = 0
  offsetstatus = 0
  atonstatus = 0
  isvirtual = 0
  serverTime = 0
  shipid = 0

  getLatlng() {
    return new L.LatLng(this.lat, this.lng)
  }
}

// 解决canvasLayer响应式的问题
const layer = {
  markersLayer: null as any,
}

export class NavigationServiceImpl {
  private _map: L.Map
  private _canvasNavigationsPane!: HTMLCanvasElement
  private items: { [mmsi: string]: L.Marker }
  private _selectedNavigation: any
  private _showState: boolean
  private requesting: any

  private options: {
    onClick?: (e: any) => void
    onHover?: (e: any) => void

    flyToZoom: number
    bigIconZoom: number
    iconScale: number
    smallIconScale: number
    isShow: boolean
    isShowTooltip: boolean
    isSelectedShowReal: boolean
    methods?: any
  } = {
    flyToZoom: 10,
    bigIconZoom: 6,
    iconScale: 0.6,
    smallIconScale: 1,
    isShow: true,
    isShowTooltip: true,
    isSelectedShowReal: true,
  }

  constructor(map: L.Map, options?: any) {
    this._map = map
    L.Util.extend(this.options, options)
    this._setupCanvas()
    layer.markersLayer = canvasIconLayer({
      pane: this._map.getPanes().divCanvasNavigationsPane,
    }).addTo(this._map)
    this._setupEventListeners()
    this.items = {}
    this._showState = this.options.isShow
    this._selectedNavigation = null
    this.requesting = null
    if (this._showState) {
      this.show()
    }
  }

  // 特别注意 panes.overlayPane 如果都放在leaflet-pane leaflet-overlay-pane 中会存在不能同时选中的问题
  private _setupCanvas(): void {
    const panes = this._map.getPanes()
    panes.canvasNavigationsPane && panes.canvasNavigationsPane.remove()
    if (!panes.divCanvasNavigationsPane) {
      panes.divCanvasNavigationsPane = L.DomUtil.create(
        'div',
        'div-canvas-navigations',
        panes.mapPane // panes.overlayPane
      )
    }
    if (!this._canvasNavigationsPane) {
      this._canvasNavigationsPane = L.DomUtil.create(
        'canvas',
        'canvas-navigations',
        panes.divCanvasNavigationsPane
      )
      this._canvasNavigationsPane.width = this._map.getSize().x
      this._canvasNavigationsPane.height = this._map.getSize().y
    }
    panes.canvasNavigationsPane = this._canvasNavigationsPane
  }

  private _setupEventListeners(): void {
    layer.markersLayer.addOnClickListener((e: any, data: any) => {
      if (this.options.onClick) {
        this.options.onClick(data)
      }
    })
    layer.markersLayer.addOnHoverListener((e: any, data: any) => {
      if (this.options.onHover) {
        this.options.onHover(data)
      }
    })
    this._map.on(
      'moveend',
      () => {
        throttle(() => {
          this._resetCanvas()
          if (this._showState) {
            setTimeout(() => {
              this.show()
              if (
                this._selectedNavigation &&
                !this.getNavigationByMMSI(this._selectedNavigation.mmsi)
              ) {
                this.addMarker(this._selectedNavigation)
              }
            }, 100)
          } else {
            if (this._selectedNavigation) {
              this.addMarker(this._selectedNavigation)
            }
          }
        }, 1000)()
      },
      this
    )
  }

  /**
   * 添加航标
   *  添加航标、按MMSI自动覆盖
   * @params
   */
  addMarker(data: CanvasNavigation) {
    this.items[data.mmsi] && this.removeMarkerByMMSI(data.mmsi)
    const iconOptions = this._getIconOptions(data)
    const marker = L.marker(
      CanvasShipUtils.GPSEncryptByMapToLatLng(
        L.latLng(data.lat, data.lng),
        this._map
      ),
      {
        icon: L.icon(iconOptions),
        data,
      } as any
    )
    if (this.options.isShowTooltip) {
      const language = 'cn' == 'cn'
      let html = ''
      html +=
        '<div style="background: #fff;padding:2px;border-radius:3px;line-height:18px;width:fit-content;font-size:12px;min-width:200px;">'
      html += `<p style="font-size:12px"><span style="color:#666">
        航标类型：</span> ${
          language
            ? this.getNavigationType(data.type)
            : this.getNavigationTypeEn(data.type)
        }</p>`
      html += `<p style="font-size:12px"><span style="color:#666">
        航标名称：</span> ${data.name}</p>`
      html += `<p style="font-size:12px"><span style="color:#666">
        航标分类：</span> ${0 == data.isvirtual ? '真实航标' : '虚拟航标'}</p>`
      html += `<p style="font-size:12px"><span style="color:#666">
        更新时间：</span> ${CommUtils.dataFormat(data.lastdyn * 1000)}</p>`
      html += '</div>'
      marker.bindTooltip(html, {
        offset: [10, 10],
        direction: 'right',
      })
    }
    layer.markersLayer.addMarker(marker)
    this.items[data.mmsi] = marker
    this._selectedNavigation &&
      this._selectedNavigation.mmsi == data.mmsi &&
      this._drawSelectedPosition(this._selectedNavigation)
  }
  /**
   * 添加多个航标
   *  添加航标、按MMSI自动覆盖
   * @params
   */
  addMarkers(data: CanvasNavigation[]) {
    let selectedNavigation = null
    for (const datum of data) {
      if (
        this._selectedNavigation &&
        this._selectedNavigation.mmsi == datum.mmsi
      ) {
        selectedNavigation = datum
      } else {
        this.addMarker(datum)
      }
    }
    selectedNavigation && this.addMarker(selectedNavigation)
  }
  _requestNavigationDatas(cb: { (resData: any): void; (arg0: any): any }) {
    if (this.requesting) {
      clearTimeout(this.requesting)
    }
    this.requesting = setTimeout(() => {
      let url = ShipxyOptions.shipDataServer.getNavigationUrl
      const areas = []
      const bounds = this._map.getBounds()
      const { lng: sLng, lat: sLat } = bounds.getSouthWest()
      const { lng: NLng, lat: NLat } = bounds.getNorthEast()
      areas.push(1000000 * sLng, 1000000 * sLat, 1000000 * NLng, 1000000 * NLat)
      url = url.replace('{level}', '2').replace('{area}', areas.join())
      console.log('TODO: 网络请求', url)
      const done = (result: any) => cb && cb(result)
      this.options.methods && this.options.methods(areas, done)
      !this.options.methods && done(resultDatas)
    }, 100)
  }

  _scaleIcon(iconOptions: L.IconOptions, scale: number): void {
    iconOptions.iconSize![0] *= scale
    iconOptions.iconSize![1] *= scale
    iconOptions.iconAnchor![0] *= scale
    iconOptions.iconAnchor![1] *= scale
  }
  _getIconOptions(data: {
    type: number
    isvirtual: any
    mmsi: any
  }): L.IconOptions {
    const iconOptions = this._getIconOptionsReal(data.type, data.isvirtual)
    const isSmallIcon =
      this._map.getZoom() < this.options.bigIconZoom &&
      (this.options.isSelectedShowReal && this._selectedNavigation
        ? this._selectedNavigation.mmsi !== data.mmsi
        : true)

    if (isSmallIcon) {
      iconOptions.iconUrl = `${ShipxyOptions.data_img.navigarion.navi0}`
      iconOptions.iconSize = [12, 12]
      iconOptions.iconAnchor = [6, 6]
      this._scaleIcon(iconOptions, this.options.smallIconScale)
    } else {
      this._scaleIcon(iconOptions, this.options.iconScale)
    }

    return iconOptions
  }
  _getIconOptionsReal(type: number, isvirtual: any): L.IconOptions {
    let typeKey = null
    switch (type) {
      case 0:
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
      case 6:
      case 7:
      case 8:
      case 31:
      default:
        typeKey = 1
        break
      case 9:
      case 20:
        typeKey = 3
        break
      case 10:
      case 21:
        typeKey = 5
        break
      case 11:
      case 22:
        typeKey = 7
        break
      case 12:
      case 23:
        typeKey = 9
        break
      case 13:
      case 15:
      case 24:
      case 26:
        typeKey = 11
        break
      case 14:
      case 16:
      case 25:
      case 27:
        typeKey = 13
        break
      case 17:
      case 28:
        typeKey = 15
        break
      case 18:
      case 29:
        typeKey = 17
        break
      case 19:
      case 30:
        typeKey = 19
    }

    let iconOPtions = {
      iconUrl:
        ShipxyOptions.data_img.navigarion[
          `navi${isvirtual ? typeKey + 1 : typeKey}`
        ],
      iconSize: [22, 22] as PointExpression,
      iconAnchor: [11, 11] as PointExpression,
    }
    switch (typeKey) {
      case 1:
        iconOPtions = {
          ...iconOPtions,
          iconSize: [22, 22],
          iconAnchor: [11, 11],
        }
        break
      case 3:
      case 5:
      case 7:
      case 9:
      case 15:
        iconOPtions = {
          ...iconOPtions,
          iconSize: [22, 36],
          iconAnchor: [11, 25],
        }
        break
      case 11:
      case 13:
      case 17:
      case 19:
        iconOPtions = {
          ...iconOPtions,
          iconSize: [22, 30],
          iconAnchor: [11, 19],
        }
    }
    return iconOPtions
  }
  _removeMarker(markerItem: L.Marker<any>, isRemove: boolean) {
    if (markerItem) {
      layer.markersLayer.removeMarker(markerItem, isRemove)
      delete this.items[(markerItem.options as any).data.mmsi]
    }
  }
  /**
   * 擦除所有航标
   *  擦除所有航标（内存对象未删除）
   */
  clearMarker() {
    layer.markersLayer.clearLayers()
  }

  /**
   * 移除航标
   * @params mmsi	String	航标标识MMSI
   * @params redraw	Boolean	是否刷新视图
   */
  removeMarkerByMMSI(mmsi: string | number) {
    this.items[mmsi] && this._removeMarker(this.items[mmsi], true)
  }
  /**
   * 移除所有航标
   */
  removeAllMarker() {
    this.clearMarker()
    this.items = {}
  }
  /**
   * 重绘所有航标
   */
  recoveryMarker() {
    this.clearMarker()
    let item = null
    for (const key in this.items) {
      if (this._selectedNavigation && this._selectedNavigation.mmsi == key) {
        item = this.items[key]
      } else {
        layer.markersLayer.addMarker(this.items[key])
      }
    }
    item && layer.markersLayer.addMarker(item)
  }
  /**
   * 航标图层重绘
   */
  redraw() {
    layer.markersLayer.redraw()
  }
  /**
   * 通过MMSI定位航标
   * @params mmsi	String	航标标识MMSI
   */
  locationNavigationByMMSI(mmsi: any, isRequest: boolean | undefined) {
    const shipNavigation = this.getNavigationByMMSI(mmsi, isRequest)
    this.locationNavigation(shipNavigation)
    return shipNavigation
  }
  /**
   * 定位航标对象
   * @params navigation		航标对象
   */
  locationNavigation(navigation: { lat: number; lng: number }) {
    if (navigation) {
      this._selectedNavigation = navigation
      this._map.flyTo(
        L.latLng(navigation.lat, navigation.lng),
        this.options.flyToZoom,
        {
          animate: false,
        }
      )
      this._showState || this.addMarker(this._selectedNavigation)
    }
  }
  /**
   * 设置选中
   * @params mmsi	String	航标标识MMSI
   */
  setSelectedNavigation(mmsi: any) {
    mmsi && (this._selectedNavigation = this.getNavigationByMMSI(mmsi, true))
    this._selectedNavigation && this.addMarker(this._selectedNavigation)
  }
  /**
   * 取消选中
   */
  cancelSelected() {
    const selectedNavigation = this._selectedNavigation
    if (selectedNavigation) {
      this._selectedNavigation = null
      this._clearSelectedPosition()
      this._showState ? this.addMarker(selectedNavigation) : this.clearMarker()
    }
  }
  _drawSelectedPosition(ship: { mmsi: string | number }) {
    this._clearSelectedPosition()
    const canvas = this._canvasNavigationsPane.getContext(
      '2d'
    ) as CanvasRenderingContext2D
    const item = this.items[ship.mmsi]
    const point = this._map.latLngToContainerPoint(item.getLatLng())
    const iconSize = item.options.icon!.options.iconSize
    const iconAnchor = item.options.icon!.options.iconAnchor
    const iconScale1 = 8 * this.options.iconScale
    const iconScale2 = 6 * this.options.iconScale
    const x1 = point.x - iconAnchor![0]
    const y1 = point.y - iconAnchor![1]
    const x2 = point.x + (iconSize![0] - iconAnchor![0])
    const y2 = point.y + (iconSize![1] - iconAnchor![1])
    canvas.save()
    canvas.beginPath()
    canvas.moveTo(x1 - iconScale1, y1 + iconScale1 - iconScale2)
    canvas.lineTo(x1 - iconScale1, y1 - iconScale1)
    canvas.moveTo(x1 - iconScale1, y1 - iconScale1)
    canvas.lineTo(x1 + iconScale1 - iconScale2, y1 - iconScale1)
    canvas.moveTo(x2 - iconScale1 + iconScale2, y1 - iconScale1)
    canvas.lineTo(x2 + iconScale1, y1 - iconScale1)
    canvas.moveTo(x2 + iconScale1, y1 - iconScale1)
    canvas.lineTo(x2 + iconScale1, y1 + iconScale1 - iconScale2)
    canvas.moveTo(x2 + iconScale1, y2 - iconScale1 + iconScale2)
    canvas.lineTo(x2 + iconScale1, y2 + iconScale1)
    canvas.moveTo(x2 + iconScale1, y2 + iconScale1)
    canvas.lineTo(x2 - iconScale1 + iconScale2, y2 + iconScale1)
    canvas.moveTo(x1 + iconScale1 - iconScale2, y2 + iconScale1)
    canvas.lineTo(x1 - iconScale1, y2 + iconScale1)
    canvas.moveTo(x1 - iconScale1, y2 + iconScale1)
    canvas.lineTo(x1 - iconScale1, y2 - iconScale1 + iconScale2)
    canvas.closePath()
    canvas.strokeStyle = 'red'
    canvas.lineWidth = 1
    canvas.lineJoin = 'round'
    canvas.stroke()
    canvas.restore()
  }
  _clearSelectedPosition() {
    const { width, height } = this._canvasNavigationsPane
    const canvas = this._canvasNavigationsPane.getContext(
      '2d'
    ) as CanvasRenderingContext2D
    canvas.clearRect(0, 0, width, height)
    canvas.save()
  }

  private getMapTransform(map: any): string {
    const style = map._mapPane.getAttribute('style')
    let transformCss = ''
    const translateKey = L.Browser.ie ? 'translate' : 'translate3d'
    const translateIndex = style.indexOf(`transform: ${translateKey}(`)

    if (translateIndex !== -1) {
      const endOfTransform = style.indexOf(')', translateIndex)
      const translateValue = style
        .substring(
          translateIndex + `transform: ${translateKey}(`.length,
          endOfTransform
        )
        .split(',')
      const [x, y] = translateValue.map(
        (val: string) => Number.parseInt(val, 10) * -1
      )

      transformCss = `${translateKey}(${x}px,${y}px`
      if (!L.Browser.ie) {
        transformCss += `,${translateValue[2]}`
      }
      transformCss += ')'
    }

    return transformCss
  }

  _resetCanvas() {
    const map = this._map
    this._canvasNavigationsPane.width = map.getSize().x
    this._canvasNavigationsPane.height = map.getSize().y
    const initialTransformValue = this.getMapTransform(map)
    this._canvasNavigationsPane.style.transform = initialTransformValue
    this._map.getPanes().canvasNavigationsPane = this._canvasNavigationsPane

    // 假设在应用初始transform之前保存了元素的初始位置
    const initialRect = this._canvasNavigationsPane.getBoundingClientRect()
    // 2. 使用requestAnimationFrame在下一帧渲染时检查并调整transform值
    requestAnimationFrame(() => {
      // 检查应用初始transform值后是否存在位移
      const rectAfterInitialTransform =
        this._canvasNavigationsPane.getBoundingClientRect()
      const displacement = {
        x: rectAfterInitialTransform.x - initialRect.x,
        y: rectAfterInitialTransform.y - initialRect.y,
      }

      if (displacement.x !== 0 || displacement.y !== 0) {
        // 调整transform值以补偿位移
        const adjustedTransform = `${initialTransformValue} translate(${-displacement.x}px, ${-displacement.y}px)`
        this._canvasNavigationsPane.style.transform = adjustedTransform
      }
    })
  }
  /**
   * 获取航标信息
   * @params mmsi		航标标识MMSI
   * @params isRequest		是否请求服务器数据
   */
  getNavigationByMMSI(mmsi: string, isRequest = false) {
    let shipNavigation = null
    if (this.items[mmsi]) {
      shipNavigation = (this.items[mmsi].options as any).data
    } else {
      if (isRequest) {
        // $.ajax({
        //   url: ShipxyOptions.shipDataServer.getNavigationUrlShipxy.replace(
        //     '{0}',
        //     mmsi
        //   ),
        //   type: 'get',
        //   async: false,
        //   dataType: 'json',
        //   success(resData) {
        //     'string' == typeof resData && (resData = JSON.parse(resData))
        //     if (0 == resData.status && resData.data.length > 0) {
        //       const dataItem = resData.data[0]
        //       const ship = new CanvasNavigation()
        //       ship.mmsi = dataItem.mmsi
        //       ship.lng = dataItem.lon / 1000000
        //       ship.lat = dataItem.lat / 1000000
        //       ship.lastdyn = dataItem.lasttime
        //       ship.type = dataItem.atontype
        //       ship.shiptype = 'navigation'
        //       ship.name = dataItem.atonname
        //       ship.length = dataItem.length / 10
        //       ship.width = dataItem.width / 10
        //       ship.left = dataItem.left / 10
        //       ship.trail = dataItem.trail / 10
        //       ship.offsetstatus = dataItem.offsetstatus
        //       ship.atonstatus = dataItem.atonstatus
        //       ship.isvirtual = dataItem.isvirtual
        //       shipNavigation = ship
        //     } else {
        //       shipNavigation = null
        //     }
        //   },
        //   error() {
        //     console.log('获取单航标信息失败')
        //     shipNavigation = null
        //   },
        // })
      } else {
        shipNavigation = this.items[mmsi] || null
      }
    }
    return shipNavigation
  }
  /**
   * 航标图层显示
   */
  show() {
    this._requestNavigationDatas((resData: any) => {
      this.removeAllMarker()
      this.addMarkers(resData)
    })
    this._showState = true
  }

  /**
   * 隐藏图层
   */
  hide() {
    this.removeAllMarker()
    this._showState = false
    this._selectedNavigation && this.cancelSelected()
  }
  /**
   * 根据航标类型代码获取航标类型
   * @params typeCode		航标类型代码
   */
  getNavigationType(typeCode: string | number) {
    const typeList = [
      '未知',
      '参考点',
      '雷达应答器',
      '近海固定建筑物，如石油平台、风力发电厂',
      '应急沉船示位标',
      '全向灯桩',
      '扇形光弧灯桩',
      '前引导灯桩',
      '后引导灯桩',
      '灯桩和立标（北方位）',
      '灯桩和立标（东方位）',
      '灯桩和立标（南方位）',
      '灯桩和立标（西方位）',
      '灯桩和立标（左侧标）',
      '灯桩和立标（右侧标）',
      '灯桩和立标（推荐航道左侧标）',
      '灯桩和立标（推荐航道右侧标）',
      '灯桩和立标（孤立危险物标志）',
      '灯桩和立标（安全水域标志）',
      '灯桩和立标（专用标志）',
      '北方位标',
      '东方位标',
      '南方位标',
      '西方位标',
      '左侧标',
      '右侧标',
      '推荐航道左侧标',
      '推荐航道右侧标',
      '孤立危险物标志',
      '安全水域标志',
      '专用标志',
      '灯塔/大型助航浮标/钻探平台',
    ]
    return typeList[typeCode] || typeList[0]
  }
  /**
   * 根据航标类型代码获取航标类型
   * @params typeCode		航标类型代码
   */
  getNavigationTypeEn(typeCode: string | number) {
    const typeList = [
      'Unknown',
      'Reference point',
      'Radar transponder',
      'Offshore fixed buildings, such as oil platforms and wind power plants',
      'Emergency sunken position indicator',
      'Omnidirectional beacon',
      'Fan light arc lamp post',
      'Front guide light post',
      'Rear guide light post',
      'Light posts and signs (North)',
      'Light posts and signs (Eastern)',
      'Light posts and signs (South)',
      'Light posts and signs (Western)',
      'Light post and vertical sign (Left)',
      'Light posts and vertical signs (Right)',
      'Light posts and vertical signs (recommended channel left sign)',
      'Light posts and signposts (right side of recommended channel)',
      'Light posts and vertical signs (isolated hazard signs)',
      'Light posts and signs (signs of safe waters)',
      'Light posts and signs (special signs)',
      'Northern beacon',
      'Oriental beacon',
      'Southern beacon',
      'Western landmark',
      'Left label',
      'Right label',
      'Left marker of recommended channel',
      'Right marker of recommended channel',
      'Isolated dangerous goods sign',
      'Safe water area sign',
      'Special signs',
      'Lighthouse/large navigation buoy/drilling platform',
    ]
    return typeList[typeCode] || typeList[0]
  }
}
